import { useQuery } from '@tanstack/react-query';
import { CareType, getBetterhelpReferralDetails, getBetterhelpReferralDetailsByInviteToken } from '@uplift/api';
import { useCurrentuser } from '@uplift/contexts';
import { useStore } from '@uplift/hooks';


export const useBetterhelpReferralDetailsQuery = (inviteToken?: string) => {
  const { authStore } = useStore();

  return useQuery({
    queryKey: [ 'betterhelp-invite', inviteToken ],
    queryFn: () => getBetterhelpReferralDetailsByInviteToken(inviteToken),
    select: data => data.data,
    enabled: !authStore.isLoggedIn && !!inviteToken,
  });
};

export const useCurrentUserBetterhelpReferralDetailsQuery = () => {
  const me = useCurrentuser();
  const { authStore } = useStore();

  return useQuery({
    queryKey: [ 'betterhelp-invite', me?.id ],
    queryFn: () => getBetterhelpReferralDetails(),
    select: data => data.data,
    enabled: authStore.isLoggedIn,
    staleTime: Infinity,
    cacheTime: Infinity,
  });
};


export const useBetterhelpReferralDetails = (inviteToken: string | undefined) => {
  const { data: inviteReferralData } = useBetterhelpReferralDetailsQuery(inviteToken);
  const { data: userReferralData } = useCurrentUserBetterhelpReferralDetailsQuery();
  const referralData = inviteReferralData || userReferralData;

  return {
    firstName: referralData?.memberFirstName ?? '',
    lastName: referralData?.memberLastName ?? '',
    email: referralData?.email ?? '',

    // defaults
    sessionsCount: referralData?.sessionCount ?? 0,
    careType: CareType.psychiatry,
    orgName: 'Betterhelp',
    eapName: referralData?.eapName,
  };
};
